"use strict";

!function ($) {
    var slideshow = $(".blocks-and-slideshow");

    if(slideshow.length) {
        slideshow.each(function (){
            var bars = $(this).find('.blocks-and-slideshow-bars');
          if(bars){
            bars.find('.bar').on("click", function () {
                slideshow.find('.bar').removeClass('is-selected');
                slideshow.find('.bar[data-step="'+$(this).data('step')+'"]').addClass('is-selected');
                slideshow.find('.dot[aria-label="Page dot '+$(this).data('step')+'"]').click();
            });
            $(document).on("DOMSubtreeModified", ".flickity-page-dots", function () {
                var index = $('.flickity-page-dots .is-selected').index() + 1;
                slideshow.find('.bar').removeClass('is-selected');
                slideshow.find('.bar[data-step="'+index+'"]').addClass('is-selected');
            });
          }
        });
      }
}(jQuery);

/*Accordian Section hide and show start*/
$("a.btn.enhanced-web-home-banner").click(function () {
  $(".enhanced-web-block1,.enhanced-web-block2,.enhanced-web-block3").show();
    window.scrollTo(0, 1108);
  $(".enhanced-web-block3").next().find("#toggle_button").show();
});
$(document).on("click", "a#toggle_button", function (e) {
  e.preventDefault();
  $(".enhanced-web-block1,.enhanced-web-block2,.enhanced-web-block3").hide();
  $(".enhanced-web-block3").next().find("#toggle_button").hide();
 $('html, body').animate({
    scrollTop: 0,
}, 100);
});
$(".enhanced-web-home-banner .lazyloaded.medium-up--hide").click(function () {
   window.scrollTo(0, 600);
  $(".slideshow-container").show();
});
$(document).on("click", "a#toggle_button_mobile", function (e) {
  e.preventDefault();
  $(".slideshow-container").hide();
  $('html, body').animate({
    scrollTop: 0,
}, 100);
});
/*Accordian Sectiong hide and show stop*/
/*Accordian Section hide and show start*/
// setInterval(function () {
//   var isSelected = document
//     .querySelector(".enhanced-web-home-banner")
//     .classList.contains("is-selected");
//   if (isSelected) {
//     $(".mobile_image_bottom").show();
//   } else {
//     $(".mobile_image_bottom").hide();
//     $(".slideshow-container").hide();
//     $(".enhanced-web-block1,.enhanced-web-block2,.enhanced-web-block3").hide();
//     $(".enhanced-web-block3").next().find("#toggle_button").hide();
//   }
// }, 1000);
/*Accordian Sectiong hide and show stop*/
// setInterval(function () {
//   var isSelected = document
//     .querySelector(".hp-banner")
//     .classList.contains("is-selected");
//   if (isSelected) {
//     // console.log(isSelected);
//     $(".mobile_image_bottom").show();
//       // $(".slideshow-container").hide();
//     $(".enhanced-web-block1,.enhanced-web-block2,.enhanced-web-block3").hide();
//     $(".enhanced-web-block3").next().find("#toggle_button").hide();
//   } 
// },1000);

 
